import { render, staticRenderFns } from "./UnitIndex.vue?vue&type=template&id=ffeb81d8&scoped=true&"
import script from "./UnitIndex.vue?vue&type=script&lang=js&"
export * from "./UnitIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeb81d8",
  null
  
)

export default component.exports